var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.509295,
    d: "M7.3125 2.28125C7.08398 2.30664 6.72852 2.35742 6.5 2.4082C6.60156 2.58594 6.67773 2.91602 6.70312 3.09375C6.70312 3.88086 6.04297 4.51562 5.28125 4.51562C5.07812 4.51562 4.74805 4.43945 4.5957 4.33789C4.51953 4.56641 4.46875 4.89648 4.46875 5.125C4.46875 6.69922 5.73828 7.96875 7.3125 7.96875C8.88672 7.96875 10.1562 6.69922 10.1562 5.125C10.1562 3.57617 8.88672 2.28125 7.3125 2.28125ZM14.5234 4.76953C13.1523 2.07812 10.4102 0.25 7.3125 0.25C4.18945 0.25 1.44727 2.07812 0.0761719 4.76953C0.0253906 4.87109 0 5.02344 0 5.15039C0 5.25195 0.0253906 5.4043 0.0761719 5.50586C1.44727 8.19727 4.18945 10 7.3125 10C10.4102 10 13.1523 8.19727 14.5234 5.50586C14.5742 5.4043 14.5996 5.25195 14.5996 5.125C14.5996 5.02344 14.5742 4.87109 14.5234 4.76953ZM7.3125 8.78125C4.79883 8.78125 2.48828 7.38477 1.26953 5.125C2.48828 2.86523 4.79883 1.46875 7.3125 1.46875C9.80078 1.46875 12.1113 2.86523 13.3301 5.125C12.1113 7.38477 9.80078 8.78125 7.3125 8.78125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.e8d8fbe6d332a4d01156733b8a9b4a4d.svg";
export { ForwardRef as ReactComponent };